import React from "react";
import "./Policy.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">

      <div className="policy-hero">
        <h1>Privacy Policy</h1>
        {/* <p>
          Your privacy is important to us. This policy explains how
          E-Advisors Solution collects, uses, protects, and manages
          information provided through our website.
        </p> */}
      </div>

      <div className="policy-container">

        <section className="policy-section">
          <h2>📌 Privacy Policy</h2>

          <p>
            This privacy policy sets out how E-Advisors Solution uses and
            protects any information that you provide when you use this website.
          </p>

          <p>
            We may change this policy from time to time by updating this page
            without notice. You acknowledge and agree that it is your
            responsibility to review this Privacy Policy periodically to
            familiarize yourself with any modifications.
          </p>

          <p>
            Your continued use of this site after such modifications will
            constitute your acknowledgment and acceptance of the updated terms.
          </p>
        </section>

        <section className="policy-section">
          <h2>📋 What We Collect</h2>

          <div className="policy-card">
            <ul>
              <li>Name and personal identification details</li>

              <li>
                Contact information including email address and phone number
              </li>

              <li>
                Demographic information such as postcode, preferences, and
                interests
              </li>

              <li>
                Other information relevant to customer surveys and/or offers
              </li>
            </ul>
          </div>
        </section>

        <section className="policy-section">
          <h2>⚙️ What We Do With the Information We Gather</h2>

          <div className="policy-card">
            <ul>
              <li>Internal record keeping</li>

              <li>Improving our products and services</li>

              <li>
                Sending periodic promotional emails about new services,
                offers, or other information that may interest you using
                the email address you have provided
              </li>

              <li>
                Contacting you for market research purposes by email,
                phone, or mail
              </li>

              <li>
                Customizing the website according to your interests
              </li>

              <li>Improving customer service</li>

              <li>
                Improving our website functionality and user experience
              </li>
            </ul>
          </div>
        </section>

        <section className="policy-section">
          <h2>🍪 How We Use Cookies</h2>

          <p>
            A cookie is a small file that asks permission to be placed on your
            computer's hard drive. Once accepted, the file is added and helps
            analyze web traffic or lets you know when you visit a particular site.
          </p>

          <p>
            Cookies allow web applications to respond to you as an individual.
            The application can tailor its operations to your needs, likes,
            and dislikes by gathering and remembering information about your
            preferences.
          </p>

          <p>
            We use traffic log cookies to identify which pages are being used
            and to enhance user experience. This helps us analyze webpage
            traffic data and improve our website to better meet customer needs.
            This information is used only for statistical analysis purposes.
          </p>

          <p>
            Overall, cookies help us provide a better website experience by
            enabling us to monitor which pages users find useful. A cookie
            does not give us access to your computer or any personal information
            other than the data you choose to share with us.
          </p>

          <div className="highlight-box">
            You can choose to accept or decline cookies. Most web browsers
            automatically accept cookies, but you can usually modify your
            browser settings to decline cookies if you prefer. This may
            prevent you from taking full advantage of the website.
          </div>
        </section>

        <section className="policy-section">
          <h2>🔒 Security</h2>

          <p>
            E-Advisors Solution adopts appropriate data collection, storage,
            and processing practices along with security measures to protect
            against unauthorized access, alteration, disclosure, or destruction
            of your personal information, username, password, transaction
            information, and data stored on our website.
          </p>
        </section>

        <section className="policy-section">
          <h2>🌐 Links to Other Websites</h2>

          <p>
            Our website may contain links to other websites of interest.
            However, once you leave our website using these links, please
            note that we do not have any control over those external websites.
          </p>

          <p>
            Therefore, we cannot be responsible for the protection and privacy
            of any information you provide while visiting such websites.
            Such websites are not governed by this privacy policy.
          </p>

          <div className="highlight-box">
            We recommend that you exercise caution and review the privacy
            policies applicable to the respective websites.
          </div>
        </section>

        <section className="policy-section">
          <h2>💳 Third-Party Payment Gateway</h2>

          <p>
            All payment-related transactions are processed through secure
            third-party payment gateway providers.
          </p>

          <p>
            These providers may have their own terms, conditions, and
            privacy policies regarding the information required for
            processing transactions.
          </p>

          <p>
            Accepted payment methods may include Visa, MasterCard,
            American Express, UPI, Net Banking, Wallets, and other
            methods made available from time to time by the payment processor.
          </p>

          <div className="highlight-box">
            We recommend that you review the privacy policies of these
            third-party payment providers to understand how your personal
            information will be handled by them.
          </div>
        </section>

        <section className="policy-section">
          <h2>🛡️ Controlling Your Personal Information</h2>

          <p>
            E-Advisors Solution will not sell, distribute, or lease your
            personal information to third parties unless required by law
            or unless we have your permission.
          </p>

          <p>
            We may use your personal information to send promotional
            information about third-party services that we think you may
            find interesting if you choose to receive such communications.
          </p>

          <p>
            If you believe that any information we are holding about you
            is incorrect or incomplete, please contact us through our
            official website:
          </p>
        </section>

        <div className="website-card">
          <h3>🌐 Official Website</h3>

          <a
            href="https://e-advisorssolution.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://e-advisorssolution.com
          </a>
        </div>

      </div>
    </div>
  );
};

export default PrivacyPolicy;

